<template>
  <div class="topbg">
    <div class="bg"></div>
    <div class="misk"></div>
    <div class="bgInfo">
      <h1 class="title">{{ title }}</h1>
      <p class="de">
        当前位置：河北睿银金融服务外包有限公司 <span v-if="text">></span> {{ text }} <span>></span>
        {{ title }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Topbg",
  data() {
    return {

    };
  },
  props:['title', 'text'],
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.topbg {
  position: relative;
  .bg {
    width: 100%;
    height: 400px;
    background: url("../assets/bg.png") no-repeat;
    background-size: 100% 100%;
    .title {
      color: #fff;
    }
  }
  .misk {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 400px;
    background-color: rgba(48, 48, 48, 0.5);
    z-index: 1;
  }
  .bgInfo {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    .title {
      margin: 0;
      font-size: 52px;
      color: #fff;
    }
    .de {
      color: #fff;
      span {
        color: #d63384;
      }
    }
  }
}
</style>